import {
  FETCH_INFO_PRODUCTS_REQUEST,
  FETCH_INFO_PRODUCTS_SUCCESS,
  FETCH_INFO_PRODUCTS_FAILURE,
  CLEAR_INFO_PRODUCTS,
} from '../actions/infoProductsActions';

const initialState = { byCategoryId: {} };

const infoProductsReducer = ( state = initialState, action ) => {
  switch ( action.type ) {
  case FETCH_INFO_PRODUCTS_REQUEST:
    return {
      ...state,
      byCategoryId: {
        ...state.byCategoryId,
        [action.payload.categoryId]: {
          ...( state.byCategoryId[action.payload.categoryId] || {} ), // Validar si el objeto existe
          loading: true,
          error: null,
        },
      },
    };
  case FETCH_INFO_PRODUCTS_SUCCESS:
    return {
      ...state,
      byCategoryId: {
        ...state.byCategoryId,
        [action.payload.categoryId]: {
          ...( state.byCategoryId[action.payload.categoryId] || {} ), // Validar si el objeto existe
          data: action.payload.data,
          loading: false,
          error: null,
        },
      },
    };
  case FETCH_INFO_PRODUCTS_FAILURE:
    return {
      ...state,
      byCategoryId: {
        ...state.byCategoryId,
        [action.payload.categoryId]: {
          ...( state.byCategoryId[action.payload.categoryId] || {} ), // Validar si el objeto existe
          loading: false,
          error: action.payload.error,
        },
      },
    };
  case CLEAR_INFO_PRODUCTS:
    return {
      ...state,
      byCategoryId: {},
    };
  default:
    return state;
  }
};

export default infoProductsReducer;
